const TEMPERATURES = {
  1: "Chilled",
  2: "Hot",
  3: "Frozen",
  4: "N/A"
};

export { TEMPERATURES };
